import { mapState, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState({
      showedNotification: state => state.notifications.copied,
      isShiftPress: state => state.notifications.isShiftPress,
      fragmentsClipboard: state => state.notifications.fragmentsClipboard
    })
  },
  mounted() {
    window.addEventListener('keydown', this.onKeydown)
    window.addEventListener('keyup', this.onKeyup)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.onKeydown)
    window.removeEventListener('keyup', this.onKeyup)
  },
  methods: {
    ...mapMutations({
      setCopied: 'notifications/SET_COPIED',
      setIsShiftPress: 'notifications/SET_IS_SHIFT_PRESS',
      setFragmentsClipboard: 'notifications/SET_FRAGMENTS_CLIPBOARD',
      setNotUserSelect: 'SET_NOT_USER_SELECT'
    }),
    async onCopyText(e, copyText) {
      if (!this.isShiftPress) {
        return
      }
      e.preventDefault()
      if (this.fragmentsClipboard.find(fragment => fragment === copyText) === undefined) {
        this.setFragmentsClipboard([ ...this.fragmentsClipboard, copyText ])
        const copiedText = this.fragmentsClipboard.join(', ')
        await navigator.clipboard.writeText(copiedText)
        this.setCopied(copiedText)
      }
    },
    onKeydown(e) {
      if (e.key === 'Shift') {
        this.setIsShiftPress(true)
        this.setNotUserSelect(true)
      }
    },
    onKeyup(e) {
      if (e.key === 'Shift') {
        this.setIsShiftPress(false)
        this.setFragmentsClipboard([])
        this.setNotUserSelect(false)
      }
    }
  }
}